import type { Client, RequestContext } from "../client";
import type { GetKubernetesManifestsDiffsResponse } from "../resources/getKubernetesManifestsDiffsResponse";
import type { GetKubernetesResourceManifestByIdBffResponse } from "../resources/kubernetesResourceManifestResource";
import type { GetKubernetesResourceManifestSummariesResponse } from "../resources/kubernetesResourceManifestSummaryResource";

export class KubernetesManifestRepository {
    private client: Client;

    constructor(
        client: Client,
        private readonly requestContext: RequestContext
    ) {
        this.client = client;
    }

    getKubernetesManifest(manifestId: string) {
        return this.client.get<GetKubernetesResourceManifestByIdBffResponse>(this.requestContext, "~/bff/spaces/{spaceId}/kubernetesmanifests/{id}", {
            id: manifestId,
        });
    }

    getKubernetesManifestSummariesForDeployment(deploymentId: string) {
        return this.client.get<GetKubernetesResourceManifestSummariesResponse>(this.requestContext, "~/bff/spaces/{spaceId}/kubernetesmanifestsummaries?deploymentId={deploymentId}", {
            deploymentId,
        });
    }

    getKubernetesManifestSummariesForRunbookRun(runbookRunId: string) {
        return this.client.get<GetKubernetesResourceManifestSummariesResponse>(this.requestContext, "~/bff/spaces/{spaceId}/kubernetesmanifestsummaries?runbookRunId={runbookRunId}", {
            runbookRunId,
        });
    }

    getKubernetesManifestsDiffsForDeployment(fromDeploymentId: string, toDeploymentId: string) {
        return this.client.get<GetKubernetesManifestsDiffsResponse>(this.requestContext, "~/bff/spaces/{spaceId}/kubernetesmanifests/diff/{fromDeploymentId}/{toDeploymentId}", {
            fromDeploymentId,
            toDeploymentId,
        });
    }
}
